import { cn } from '@/lib/utils';

const OVERLAY_CLASS_NAME =
  'absolute inset-0 flex items-center justify-center bg-black/30 rounded-2xl';
const LABEL_CLASS_NAME = 'text-white text-3xl';
const DEFAULT_LABEL = '18+';

interface BlurredCoverOverlay18PlusProps {
  className?: string;
  labelClassName?: string;
  label?: string;
}

export const BlurredCoverOverlay18Plus = ({
  className,
  labelClassName,
  label = DEFAULT_LABEL,
}: BlurredCoverOverlay18PlusProps) => (
  <div className={cn(OVERLAY_CLASS_NAME, className)}>
    <span className={cn(LABEL_CLASS_NAME, labelClassName)}>{label}</span>
  </div>
);
